export default __webpack_public_path__ + "static/media/1379.d1e1a281.png";